import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AdBanner, AdSideRails, SLOT_HOMEPAGE_TOP, SLOT_HOMEPAGE_BOTTOM } from './ads/Ads';
import { useLanguage } from '../i18n/LanguageContext';

// Each module's own emoji (same icons used inside the modules / master list),
// shown inside a purple gradient badge beside the card title.
const MODULE_ICONS: Record<string, string> = {
  dictation: '🎯',
  notes: '📝',
  recite: '📚',
  writing: '✍️',
  understanding: '🧠',
  listening: '🎧',
  speaking: '🗣️',
  lecture: '🧑‍🏫',
  exam: '🎓',
};

const ModuleBadge: React.FC<{ moduleId: string }> = ({ moduleId }) => (
  <span className="module-card-badge" aria-hidden="true">
    {MODULE_ICONS[moduleId] ?? '📘'}
  </span>
);

const ModulesOverview: React.FC = () => {
  const navigate = useNavigate();
  const { dict } = useLanguage();

  const handleModuleClick = (moduleId: string) => {
    navigate(`/module/${moduleId}`);
  };

  return (
    <div className="modules-overview">
      {/* Fixed skyscraper rails pinned to the screen edges (wide screens only);
          same overlays used on each module page. */}
      <AdSideRails />
      <div className="module-navigation">
        <h2>{dict.dashboard.title}</h2>
        <p className="modules-public-note" style={{ textAlign: 'center', color: '#555', margin: '8px 0 4px' }}>
          {dict.dashboard.publicNote}
        </p>
        <AdBanner label="homepage-top" slot={SLOT_HOMEPAGE_TOP} leaderboard style={{ margin: '12px auto 20px', maxWidth: 728 }} />
        <div className="module-grid">
          {dict.dashboard.modules.map((module) => (
            <div
              key={module.id}
              className={`module-card ${module.id}-module`}
              onClick={() => handleModuleClick(module.id)}
            >
              <h3 className="module-card-title">
                <ModuleBadge moduleId={module.id} />
                <span>{module.name}</span>
              </h3>
              <p>{module.description}</p>
              <ul className="module-features">
                {module.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
              <p
                className="module-guide"
                style={{
                  fontSize: '0.82rem',
                  color: '#666',
                  borderTop: '1px solid #eee',
                  paddingTop: 8,
                  marginTop: 8,
                }}
              >
                {module.guide}
              </p>
            </div>
          ))}
        </div>
        <AdBanner label="homepage-bottom" slot={SLOT_HOMEPAGE_BOTTOM} leaderboard style={{ margin: '24px auto 0', maxWidth: 728 }} />
      </div>
    </div>
  );
};

export default ModulesOverview;
